// removed by extract-text-webpack-plugin
module.exports = {"dark":"#00171F","blue":"#00A8E8","white":"#FFFFFF","green":"#99C24D","btn":"src-components-Button----Button-module---btn---32eKb","orange":"src-components-Button----Button-module---orange---2uJg3 src-components-Button----Button-module---btn---32eKb","normal":"src-components-Button----Button-module---normal---1Zpch src-components-Button----Button-module---btn---32eKb","large":"src-components-Button----Button-module---large---2DwLF src-components-Button----Button-module---btn---32eKb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.module.css
// module id = 114
// module chunks = 35783957827783 52981426548526 267780758595360